import { apiRequest } from "@nusrif/utils";
import { ApiOrderListResponse, ApiOrderResponse } from "@nusrif/types";

/**
 * Create a new cart for the authenticated user
 */
export async function createOrder(storeOrderId: string): Promise<ApiOrderResponse> {
  const response = await apiRequest<ApiOrderResponse>('/orders', {
    method: 'POST',
    body: {
      storeOrderId
    }
  });

  return response;
}

/**
 * Get order details by order ID
 */
export async function getOrderDetails(orderId: string): Promise<ApiOrderResponse> {
  const response = await apiRequest<ApiOrderResponse>(`/orders/${orderId}`, {
    method: 'GET'
  });

  return response;
}

/**
 * Get all orders for the authenticated user
 */
export async function getOrdersList(): Promise<ApiOrderListResponse> {
  const response = await apiRequest<ApiOrderListResponse>('/orders', {
    method: 'GET'
  });

  return response;
}

/**
 * Cancel an order by order ID
 */
export async function cancelOrder(orderId: string): Promise<ApiOrderResponse> {
  const response = await apiRequest<ApiOrderResponse>(`/orders/cancel`, {
    method: 'POST',
    body: {
      id: orderId
    }
  });
  return response;
}